export default {
  namespaced: true,
  state: {
    result: {},
  },
  getters: {
    getResult(state) {
      return state.result
    },
  },
  mutations: {
    setResult(state, result) {
      state.result = result
    },
    resetResult(state) {
      state.result = {}
    },
  },
  actions: {
    async setResult({ commit }, result) {
      commit('setResult', result)
    },
    async resetResult({ commit }) {
      commit('resetResult')
    },
  },
}
